import React from 'react';
import GrandPage from '../../Components/GrandPage/GrandPage';
import TitleComponent from '../../Components/TitleComponent/TItleComponent';
import styles from './BannerBackground.module.scss';
import Image from '../../Components/ImageComponent/Image';

const BannerBackground = ({ api }) => {
  return (
    <section id={api?.id} className={`wrapper bannerImage ${styles.sectionTitleSection}`}>
      <div className={styles.topContainer}>
        <div
          className={`${styles.titleContainer} ${!!api.attributes.animationName && !api.attributes.image ? styles.center : ''}`}
          data-aos="fade-right"
          data-aos-duration="500"
          data-aos-easing="easy-in-out"
        >
          <TitleComponent
            properties={api.attributes}
            type={`${!!api.attributes.animationName && !api.attributes.image ? 'centerOnMob' : 'halfTitle'} `}
          />
          {!!api?.attributes?.text && <p className={styles.boxDescTxt}>{api.attributes.text}</p>}
        </div>
        <div className={styles.mediaContainer}>
          <Image
            type={!!api.attributes.animationName && !api.attributes.image ? 'bannerBackground' : ''}
            properties={api.attributes}
            animationData={{
              animation: 'fade-left',
              animationDuration: '1000',
              animationEasing: 'easy-in-out',
            }}
          />
        </div>
      </div>
      <div className={styles.downContainer}>
        <GrandPage
          properties={api.attributes}
          blockID={api.id}
          animationData={{
            animation: 'fade-up',
            animationDuration: '1000',
            animationEasing: 'easy-in-out',
          }}
        />
      </div>
    </section>
  );
};

export default BannerBackground;
